<template>
    <div class="relative overflow-hidden z-0">
        <StaticImage :img-key="staticImageKey" full-screen image-class="absolute w-full h-full object-cover" />

        <div
            class="container grid grid-cols-12 base-responsive-gap pt-48 sm:pt-[15rem] lg:pt-[20rem] pb-[5.5rem] relative z-2"
        >
            <div class="col-span-12 sm:col-span-10 lg:col-span-7 min-h-[15rem] flex items-end">
                <h1 class="display text-white"><T :t="titleKey" /></h1>
            </div>
        </div>

        <div class="gradient z-1"></div>

        <svg
            id="visual_mobile"
            viewBox="0 0 1280 50"
            class="absolute bottom-0 left-0 z-3 animate-wave sm:hidden"
            width="1280"
            height="50"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
        >
            <path
                d="M0 34L23.7 34.7C47.3 35.3 94.7 36.7 142 31C189.3 25.3 236.7 12.7 284.2 12.8C331.7 13 379.3 26 426.8 27.2C474.3 28.3 521.7 17.7 569 16C616.3 14.3 663.7 21.7 711 26.3C758.3 31 805.7 33 853.2 35.8C900.7 38.7 948.3 42.3 995.8 37.5C1043.3 32.7 1090.7 19.3 1138 19.3C1185.3 19.3 1232.7 32.7 1256.3 39.3L1280 46L1280 51L1256.3 51C1232.7 51 1185.3 51 1138 51C1090.7 51 1043.3 51 995.8 51C948.3 51 900.7 51 853.2 51C805.7 51 758.3 51 711 51C663.7 51 616.3 51 569 51C521.7 51 474.3 51 426.8 51C379.3 51 331.7 51 284.2 51C236.7 51 189.3 51 142 51C94.7 51 47.3 51 23.7 51L0 51Z"
                fill="#e6e6e6"
                stroke-linecap="round"
                stroke-linejoin="miter"
            ></path>
        </svg>

        <svg
            id="visual_desktop"
            class="absolute bottom-0 left-0 z-3 animate-wave hidden sm:block"
            viewBox="0 0 4000 100"
            width="4000"
            height="100"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
        >
            <path
                d="M0 90L66.7 85.8C133.3 81.7 266.7 73.3 400 73.8C533.3 74.3 666.7 83.7 800 88.5C933.3 93.3 1066.7 93.7 1200 82.2C1333.3 70.7 1466.7 47.3 1600 40.2C1733.3 33 1866.7 42 2000 54.2C2133.3 66.3 2266.7 81.7 2400 88.2C2533.3 94.7 2666.7 92.3 2800 81.3C2933.3 70.3 3066.7 50.7 3200 41C3333.3 31.3 3466.7 31.7 3600 37.5C3733.3 43.3 3866.7 54.7 3933.3 60.3L4000 66L4000 101L3933.3 101C3866.7 101 3733.3 101 3600 101C3466.7 101 3333.3 101 3200 101C3066.7 101 2933.3 101 2800 101C2666.7 101 2533.3 101 2400 101C2266.7 101 2133.3 101 2000 101C1866.7 101 1733.3 101 1600 101C1466.7 101 1333.3 101 1200 101C1066.7 101 933.3 101 800 101C666.7 101 533.3 101 400 101C266.7 101 133.3 101 66.7 101L0 101Z"
                fill="#e6e6e6"
                stroke-linecap="round"
                stroke-linejoin="miter"
            ></path>
        </svg>

        <div
            class="absolute w-full h-[60%] bottom-0 left-0 z-1"
            style="background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3))"
        ></div>
    </div>
</template>

<script>
export default {
    name: 'TopLocationHero',
    props: {
        titleKey: {
            type: String,
            required: true,
        },
        staticImageKey: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped>
.gradient {
    @apply absolute bottom-0 left-0 w-full h-[40vh];
    background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
}
@keyframes animate-wave {
    from {
        transform: translateX(-50%);
    }
    to {
        transform: translateX(0);
    }
}
.animate-wave {
    animation: animate-wave 1.5s cubic-bezier(0.21, 0.03, 0.19, 1) forwards;
}
</style>
